import React from "react";
import Footer from "@/bit/components/components.footer";
import Header from "@/bit/components/components.header";
import MetaData from "@/bit/core/core.meta-data";
import { wrapper } from "@/store";
import dynamic from "next/dynamic";
import { connect } from "react-redux";
import { getStaticProps as getStaticPropsMethod } from "@/bit/pages/pages.create-pages";

import OtherService from "@/component/other-services";
import DigitalServicesCard from "@/component/digital-services-card";
import normalizeOrionModule from "@/bit/normalizers/normalizers.orion";

const Error500 = dynamic(() => import("@/pages/500"));

class Public extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orionInfo: props.orionInfo,
    };
  }

  async handleRehydrate() {
    const module = await import("@gcloud-npm/adabyron.orion.get-by-alias");
    const { context, orionAlias } = this.props;
    const getByAlias = module.default;

    if (orionAlias && context) {
      const orionInfoData = await getByAlias({
        alias: orionAlias,
        context: context,
        build: false,
      });

      const orionInfo = await normalizeOrionModule(
        orionInfoData,
        context,
        orionAlias
      );

      console.log("rehydrate");
      this.setState((prev) => ({ ...prev, orionInfo: { ...orionInfo } }));
    }
  }

  componentDidMount() {
    if (typeof window !== "undefined") {
      if (process.env.NEXT_PUBLIC_ENV_NAME === "qa") {
        this.handleRehydrate();
      }
    }
  }

  render() {
    const filePath = "/pages/index/";
    const { breadcrumbsProps, headerProps, seoInfo, footerProps } = this.props;
    const { orionInfo } = this.state;

    if (!orionInfo) {
      return <Error500 {...{ headerProps }} />;
    }

    return (
      <>
        <MetaData seoInfo={seoInfo} />
        <Header {...breadcrumbsProps} {...headerProps} />
        <main>
          {orionInfo && orionInfo["MODULO_CARDS"] && (
            <DigitalServicesCard {...orionInfo["MODULO_CARDS"]} />
          )}
          {orionInfo && orionInfo["MODULO_VENTA_CRUZADA_OTROS_SERVICIOS"] && (
            <OtherService
              {...orionInfo["MODULO_VENTA_CRUZADA_OTROS_SERVICIOS"]}
            />
          )}
        </main>

        <Footer footerProps={footerProps} />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  context: state.main.context,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Public);

export const getStaticProps = wrapper.getStaticProps(async (data) => {
  return getStaticPropsMethod(data, "", 0, {
    pathname: "/mas-servicios",
    orionAlias: "mas-servicios",
    headerLocation: "/mas-servicios",
    seoLocation: "www.movistar.es/particulares/mas-servicios",
  });
});
